export default "__VITE_ASSET__47bd8f77__"